import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FirestoreCrud } from '../model/class/FirestoreCrud';
import { IFeedbackComment } from '../model/interface/IFeedbackComment';

@Injectable({
  providedIn: 'root',
})
export class FeedbackFirebaseService {
  private crudService: FirestoreCrud<IFeedbackComment>;

  constructor(private afs: AngularFirestore) {
    this.crudService = new FirestoreCrud<IFeedbackComment>(afs, 'fteda');
  }

  public addFeedback(data: IFeedbackComment): Promise<IFeedbackComment> {
    return this.crudService.add(data);
  }
}
